// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CategorySearch-categoryInputFlex-szt5y {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  position: relative;
  width: 100%;
  -webkit-box-shadow: 0px 4px 14px 0px #0000000F;
          box-shadow: 0px 4px 14px 0px #0000000F;
}

.CategorySearch-categorySearchBtn-Amenm {
  width: 46px;
  height: 44px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  background: var(--primary-bg);
  border: unset;
  outline: unset !important;
  padding: 13px 14px;
  border-radius: 0 4px 4px 0;
  cursor: pointer;
}

.CategorySearch-categorySearchBtn-Amenm>svg {
  width: 18px;
  height: 18px;
}`, "",{"version":3,"sources":["webpack://./src/components/Home/CategorySearch/CategorySearch.css"],"names":[],"mappings":"AAAA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,8CAAsC;UAAtC,sCAAsC;AACxC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;EACvB,6BAA6B;EAC7B,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;AACd","sourcesContent":[".categoryInputFlex {\n  display: flex;\n  align-items: center;\n  position: relative;\n  width: 100%;\n  box-shadow: 0px 4px 14px 0px #0000000F;\n}\n\n.categorySearchBtn {\n  width: 46px;\n  height: 44px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: var(--primary-bg);\n  border: unset;\n  outline: unset !important;\n  padding: 13px 14px;\n  border-radius: 0 4px 4px 0;\n  cursor: pointer;\n}\n\n.categorySearchBtn>svg {\n  width: 18px;\n  height: 18px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"categoryInputFlex": `CategorySearch-categoryInputFlex-szt5y`,
	"categorySearchBtn": `CategorySearch-categorySearchBtn-Amenm`
};
module.exports = ___CSS_LOADER_EXPORT___;
